<template>
  <div class="l8-refund-search container">
    <div class="search-area">
      <h4>退票进度查询</h4>
      <a-row>
        <a-form layout="vertical">
          <a-col :md="5" :sm="24" :xs="24">
            <a-form-item label="客票号" required>
              <a-input
                v-model.trim="etNo"
                size="large"
                :placeholder="`客票号：${ticketCode}-0000000000`"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24" :xs="24">
            <a-form-item label="证件号" required>
              <a-input
                v-model.trim="certificateNo"
                size="large"
                placeholder="请输入证件号"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24" :xs="24">
            <a-form-item label="姓名" required>
              <a-input
                v-model.trim="passengerName"
                size="large"
                placeholder="请输入姓名"
              />
            </a-form-item>
          </a-col>
          <a-col class="last-col" :md="9" :sm="24" :xs="24">
            <a-button type="primary" html-type="submit" size="large" @click="search" :loading="loading">查 询</a-button>
            <a-form-item label="验证码" required>
              <l8-imgcaptcha
                ref="verify"
                v-model.trim="captcha"
                :size="'large'"
              ></l8-imgcaptcha>
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </div>
    <div class="ticket-area" v-if="ticket">
      <div class="wrapper">
        <h4>退票进度</h4>
        <div class="ticket-psg">
          <span class="psg-title ticket-psg-item">
            <l8-icon class="l8-icon" type="icon-lvke"/>
            <span>旅客</span>
          </span>
          <span class="ticket-psg-item">{{ ticket.passengerName }}</span>
          <span class="ticket-psg-item">证件号：{{ certificateNo }}</span>
        </div>
        <div class="ticket-trip">
          <a-table
            :columns="columns"
            :dataSource="segments"
            :rowKey="(record, index) => index"
            :pagination="false"
          >
            <template slot="city" slot-scope="record">
              {{ record.orgCityName }} - {{ record.arrCityName }}
            </template>
            <template slot="airline" slot-scope="record">
              {{ (record.paxSegment.airlineCode || record.flightNo.substring(0,2) ) | airline }}
            </template>
            <template slot="depTime" slot-scope="record">
              {{ (record.paxSegment.depTime || record.depTime) | format }}
            </template>
            <template slot="flightNo" slot-scope="record">
              {{ record.paxSegment.flightNo || record.flightNo }}
            </template>
            <template slot="tickNo">
              {{ ticket.tickNo }}
            </template>
            <template slot="status" slot-scope="ticketSatus">
              {{ ticketSatus | status }}
            </template>
          </a-table>
        </div>
        <div class="ticket-progress" v-if="currentStep > -1">
          <step :steps="steps" :current="currentStep" :stepsDescription="stepsDescription"/>
        </div>
      </div>
    </div>
    <div class="rule-area">
      <div class="rule-content" v-if="refundDesc" v-html="refundDesc"> </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { nameValidate } from '@/assets/js/validate/utils/name'
import '@/components/l8-icon'
import { refundSearch } from '@/apis/service'
import getAppInfo from '@/utils/from'
import './index'

const etNoReg = /^\d{3}-\d{10}$/
const refundStatus = {
  FIRSTAUDIT: '一审',
  SECONDAUDIT: '二审',
  RESECONDAUDIT: '重新二审',
  REFUNDED: '已退票',
  SAUDIT: '补退款审核',
  SREFUNDED: '补退款',
  FPASS: '一审通过',
  PASS: '二审通过',
  PAID: '已退款',
  PEND: '退款处理中',
  PAIDING: '退款进行中',
  REJECT: '拒绝',
  FAIL: '退款失败',
  SAPPLYING: '补退申请中',
  SPASS: '补退审核通过',
  SREJECT: '补退申请被拒绝',
  ONLINE: '在线支付',
  OFFLINE: '线下支付',
  INTRADAY: '当日作废',
  UNCONSTRAINT: '自愿退票',
  CONSTRAINT: '非自愿退票',
  REPAIRREFUND: '补退票',
  'OPEN FOR USE': '已出票'
}
const airlineMap = {
  HU: '海南航空',
  JD: '首都航空',
  GS: '天津航空',
  PN: '西部航空',
  '8L': '祥鹏航空',
  CN: '大新华航空'
}
const statusList = ['NEW', 'FPASS', 'REJECT', 'PASS', 'SPASS', 'PAID', 'REFUND', 'FAIL']
const columns = [
  {
    title: '行程',
    scopedSlots: { customRender: 'city' },
    align: 'center'
  }, {
    title: '承运人',
    scopedSlots: { customRender: 'airline' },
    align: 'center'
  }, {
    title: '起飞时间',
    scopedSlots: { customRender: 'depTime' },
    align: 'center'
  }, {
    title: '航班号',
    scopedSlots: { customRender: 'flightNo' },
    align: 'center'
  }, {
    title: '舱位',
    dataIndex: 'cabin',
    align: 'center'
  }, {
    title: '票号',
    scopedSlots: { customRender: 'tickNo' },
    align: 'center'
  }, {
    title: '退票进度',
    dataIndex: 'ticketSatus',
    scopedSlots: { customRender: 'status' },
    align: 'center'
  }
]
export default {
  data () {
    return {
      columns,
      etNo: '',
      certificateNo: '',
      passengerName: '',
      captcha: '',
      ticket: null,
      segments: [],
      steps: [],
      stepsDescription: [],
      currentStep: -1,
      loading: false,
      refundDesc: window.refundDesc ? window.refundDesc.content : '',
      ticketCode: getAppInfo()?.ticketCode
    }
  },
  mounted () {
    this.getRefundDesc()
  },
  methods: {
    async getRefundDesc () {
      const cmsContent = window.__MICRO_ROOT__ ?? {}
      const pageCmsData = (await cmsContent.cms?.getPageData()) ?? {}
      this.refundDesc = _.get(pageCmsData, 'refund-content.content')
    },
    validate () {
      const { etNo, certificateNo, passengerName, captcha, ticketCode } = this

      if (!etNo) {
        return {
          success: false,
          message: '请输入您的电子客票号！'
        }
      }

      if (!certificateNo) {
        return {
          success: false,
          message: '请输入旅客证件号码！'
        }
      }

      if (!passengerName) {
        return {
          success: false,
          message: '请输入旅客姓名！'
        }
      }

      if (!etNoReg.test(etNo)) {
        return {
          success: false,
          message: `客票号正确格式为：${ticketCode}-0000000000`
        }
      }

      const nameValid = nameValidate(passengerName)

      if (!nameValid.validate) {
        return {
          success: false,
          message: nameValid.message
        }
      }

      // TODO:现在暂无接口 等待后期补全
      if (!captcha) {
        return {
          success: false,
          message: '请输入验证码！'
        }
      }

      return {
        success: true
      }
    },
    async search () {
      const valid = this.validate()

      if (!valid.success) {
        this.$message.error(valid.message)
        return
      }

      const { etNo, certificateNo, passengerName, captcha } = this
      const etNoSplit = etNo.split('-')
      this.loading = true

      const params = {
        issCode: etNoSplit[0],
        etNo: etNoSplit[1],
        certificateNo,
        passengerName,
        captcha,
        validateSchema: 'refundsearch'
      }

      try {
        const data = await refundSearch(params)
        if (data.valid === false) {
          this.$message.error(data.errors[0].message)
          this.ticket = null
          this.currentStep = -1
          this.loading = false
          return
        }

        const { ticket, firstAudit, secondAudit, refundList } = data

        this.ticket = ticket

        if (refundList && refundList.length) {
          const segments = _.cloneDeep(ticket.segment)
          refundList[0].fltRefundPaxSegList.forEach(item => {
            const { ticketIssued, depCode, arrCode, cabinClass } = item.paxSegment

            if (`${ticketIssued.issCode}-${ticketIssued.ticketNo}` === ticket.tickNo) {
              const idx = _.findIndex(segments, seg => {
                return seg.orgCity === depCode && seg.arrCity === arrCode && seg.cabin === cabinClass
              })

              segments[idx] = Object.assign({}, segments[idx], item)
            }
          })
          segments.forEach(item => {
            if (!item.paxSegment) {
              item.paxSegment = {}
            }
          })
          this.segments = segments

          const process = []
          const steps = []
          const { status } = refundList[0]
          const idx = _.findIndex(statusList, item => item === status)

          if (idx >= 0) {
            steps.push('审核中')
            process.push(moment(refundList[0].createTime).format('YYYY-MM-DD HH:mm:ss'))
          }

          if (idx >= 1) {
            steps.push('一审通过')

            if (firstAudit && firstAudit.length && firstAudit[0].submmitTime) {
              process.push(moment(firstAudit[0].submmitTime).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              process.push('')
            }
          }

          if (idx >= 2) {
            steps.push('二审通过')

            if (secondAudit && secondAudit.length && secondAudit[0].auditTime) {
              process.push(moment(secondAudit[0].auditTime).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              process.push('')
            }
          }

          if (idx === 2) {
            steps[2] = '二审拒绝'
          }

          if (idx >= 5) {
            steps.push('已退款')

            if (refundList[0].payTime) {
              process.push(moment(refundList[0].payTime).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              process.push('')
            }
          }

          if (idx >= 7) {
            steps[3] = '退款失败'
          }

          this.steps = steps
          this.currentStep = steps.length
          this.stepsDescription = process
        }
        this.loading = false
      } catch (e) {
        this.$refs.verify.refresh()
        this.ticket = null
        this.currentStep = -1
        this.loading = false
        this.$message.error(e.message || '网络异常，请稍后再试！')
      }
    }
  },
  filters: {
    status (value) {
      if (!value) {
        return '-'
      }

      return refundStatus[value] || '-'
    },
    format (value, format = 'YYYY-MM-DD') {
      if (!value) {
        return '-'
      }

      return moment(value).format(format)
    },
    airline (value) {
      if (!value) {
        return '-'
      }

      return airlineMap[value] || '-'
    }
  }
}
</script>
